import React from 'react'

import { Grid } from "@material-ui/core"
import Layout from '../components/Layout'
import Paper from '../components/Paper'
import SEO from '../components/Seo'
import Typography from '../components/Typography'

import compStyles from '../pageComponents/contactUs/contactUs.module.scss'

class HomePage extends React.Component {

  render () {
    return (
    <Layout>
      <SEO title='ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ' />
      <Paper>
        <section className={compStyles.section}>
          <Typography variant="h2" className={compStyles.heading}>ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ</Typography>
          <Grid container className={compStyles.main1} justify="space-between">
            <Grid item md={4} className={compStyles.contactInfo}>
              <Typography variant="h3" className={compStyles.contactHeading}>ವಿಳಾಸ :</Typography>
              <Typography variant="body1" className={compStyles.mainText}>ನಂ. 49/1,<br/>
                1ನೇ ಮಾಡಲ್ ಹೌಸ್ ಸ್ಟ್ರೀಟ್,<br />
                ಬಸವನಗುಡಿ, ಬೆಂಗಳೂರು
              </Typography>
              <Typography variant="body1" className={compStyles.email}>ಇಮೇಲ್ : mandyasridhar537@gmail.com</Typography>
            </Grid>
            <Grid item md={4} className={compStyles.contactInfo}>
              <Typography variant="h3" className={compStyles.contactHeading}>ಸಂಪರ್ಕ ಸಂಖ್ಯೆ :</Typography>
              <Typography variant="body1" className={compStyles.phone}>
                <a href="tel:+919845152307">+91 98451 52307</a><br/>
                <a href="tel:+917892241605">+91 78922 41605</a>
              </Typography>
            </Grid>
            <Grid item md={4} className={compStyles.contactInfo}>
              <div>
                <iframe title="map" className={compStyles.map} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d301.63348375509173!2d77.57037917269659!3d12.937634517494379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xab5bb24efea39098!2zMTLCsDU2JzE1LjUiTiA3N8KwMzQnMTMuNyJF!5e0!3m2!1sen!2sin!4v1639138648832!5m2!1sen!2sin" width="100%" height="280px" allowfullscreen="" loading="lazy"></iframe>
              </div>
            </Grid>
          </Grid>
        </section>
      </Paper>
    </Layout>
    )
  }
}

export default HomePage
